import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';

@Injectable({
  providedIn: 'root'
})
export class ApiTagsService {

  tagsSwitchSubject = new Subject<any>();
  tagsListDataSubject = new Subject<any>();
  tagsDataSubject = new Subject<any>();

  constructor(
    private apiBasic: ApiBasicService
  ) { }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }

  /**
  * 
  * @param id string
  * @returns Observable<Res>
  */
  edit(id: string): Observable<Res> {

    return this.apiBasic.edit('tags', id);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  create(params: any): Observable<Res> {

    return this.apiBasic.create('tags', params);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  update(params: any): Observable<Res> {

    return this.apiBasic.update('tags', params);
  }

  /**
   * 
   * @param params 
   * @returns 
   */
  delete(params: any): Observable<Res> {

    return this.apiBasic.delete('tags', params);
  }

  /**
  * 
  * @param data 
  */
  switchTab(data: string): void {

    this.tagsSwitchSubject.next(data);
  }

  /**
   * Method to listen for language change
   * @returns Observable<any>
   */
  listenerSwitchTab(): Observable<any> {

    return this.tagsSwitchSubject.asObservable();
  }

  /**
   * 
   * @param data 
   */
  setTagListsData(data: any): void {

    this.tagsListDataSubject.next(data);
  }

  /**
   * Method to listen for language change
   * @returns Observable<any>
   */
  listenerTagListData(): Observable<any> {

    return this.tagsListDataSubject.asObservable();
  }

  /**
   * 
   * @param data 
   */
  setTagsData(data: any): void {

    this.tagsDataSubject.next(data);
  }

  /**
   * Method to listen for language change
   * @returns Observable<any>
   */
  listenerTagData(): Observable<any> {

    return this.tagsDataSubject.asObservable();
  }

}
